import { render } from "./languageText.vue?vue&type=template&id=4800751d"
import script from "./languageText.vue?vue&type=script&lang=js"
export * from "./languageText.vue?vue&type=script&lang=js"

import "./languageText.vue?vue&type=style&index=0&id=4800751d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__